var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTotalLostRecords = function SvgTotalLostRecords(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5V1.5C4 1.22386 4.22386 1 4.5 1H12.7229C12.8953 1 13.0555 1.08881 13.1469 1.235L15.4409 4.9055C15.4795 4.96726 15.5 5.03861 15.5 5.11144V5.11144C15.5 5.32603 15.326 5.5 15.1114 5.5H13.5H29.5C29.7761 5.5 30 5.72386 30 6V20C30 20.2761 29.7761 20.5 29.5 20.5H4.5C4.22386 20.5 4 20.2761 4 20V5Z",
    stroke: "#0A6681"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10H26.5C26.7761 10 27 10.2239 27 10.5V24.5C27 24.7761 26.7761 25 26.5 25H1.5C1.22386 25 1 24.7761 1 24.5V6C1 5.72386 1.22386 5.5 1.5 5.5H9.75546C9.90975 5.5 10.0554 5.57124 10.1501 5.69303L13.5 10",
    stroke: "#0A6681",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.5V19.5",
    stroke: "#0A6681",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21V21.5",
    stroke: "#0A6681",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 10V22.5858C24 22.851 23.8946 23.1054 23.7071 23.2929L22 25",
    stroke: "#0A6681",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTotalLostRecords, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/total-lost-records.c5fce599.svg";
export { ForwardRef as ReactComponent };